module.exports = __webpack_public_path__ + "media/warehouse_by_volume/img-size24m-0a0d5c4f.png";